var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "filter-a",
    d: "M0 0h19.77v19.774H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "filter-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#filter-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.31 1.364a.947.947 0 0 0-.67 1.614l6.427 6.427c.128.128.2.301.2.482v7.558l3.239-3.239V9.887c0-.18.071-.354.2-.482l6.426-6.427a.948.948 0 0 0-.67-1.614H2.31zm5.276 18.41a.682.682 0 0 1-.682-.682v-8.923L.677 3.942A2.295 2.295 0 0 1 0 2.312 2.313 2.313 0 0 1 2.31 0h15.154c.615 0 1.194.24 1.63.675.903.901.903 2.367.003 3.267l-6.228 6.227v4.32c0 .181-.072.355-.2.482l-4.602 4.603a.68.68 0 0 1-.481.2z",
    mask: "url(#filter-b)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.61b60abff1a23a1a192bbe0edf1b3eaa.svg";
export { ForwardRef as ReactComponent };